import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';

// Developer Credits
console.log(
  '%c Created by Davit Prazyan ',
  'background: linear-gradient(90deg, #667eea 0%, #764ba2 100%); color: white; font-size: 16px; font-weight: bold; padding: 10px 20px; border-radius: 5px;'
);
console.log(
  '%c🔗 LinkedIn: https://www.linkedin.com/in/davit-prazyan/ ',
  'color: #0077b5; font-size: 14px; font-weight: bold; padding: 5px;'
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
// reportWebVitals();
